module.exports = __webpack_public_path__ + "img/monitor-access-denied.02a2a59f.svg";